export default __webpack_public_path__ + "static/1596-2d0597ad51fb7cb1e1b0f17cbdbbc262.gif";